var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { ValidationErrorGroupFactory } from "./ValidationErrorGroupFactory";
export class ValidationErrorCollection {
  constructor(_data) {
    /**
     */
    __publicField(this, "Errors");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof ValidationErrorCollection
     */
    __publicField(this, "$type", "V1.Cesop.Periods.Validation.Source.ValidationErrorCollection");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      if (_data["Errors"] && _data["Errors"].constructor === Array) {
        this.Errors = [];
        for (let item of _data["Errors"]) {
          const $typeErrors = item && item.$type;
          if ($typeErrors) {
            const errors_ = ValidationErrorGroupFactory.create($typeErrors);
            this.Errors.push(errors_.init(item));
          }
        }
      }
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    if (this.Errors && this.Errors.constructor === Array) {
      _data["Errors"] = [];
      for (let item of this.Errors) {
        _data["Errors"].push(item.toJSON());
      }
    }
    return _data;
  }
}
